import { FC } from "react";
import type { NetworkMismatch } from "@/hooks/useNetworkCheck";

const MESSAGES: Record<NonNullable<NetworkMismatch>, string> = {
  "mainnet-wallet": "Wrong network — switch wallet to Preview",
  "wrong-testnet": "Wrong testnet — switch to Preview",
};

interface NetworkMismatchBannerProps {
  mismatch: NonNullable<NetworkMismatch>;
}

export const NetworkMismatchBanner: FC<NetworkMismatchBannerProps> = ({ mismatch }) => {
  return (
    <div className="flex items-center gap-1.5 rounded-full border border-sr-tangerine/30 bg-sr-tangerine/10 px-3 py-1.5">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" className="shrink-0 text-sr-tangerine">
        <path
          d="M10 6V10.5M10 13.5V14M3.5 17H16.5L10 3L3.5 17Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-xs font-medium text-sr-tangerine whitespace-nowrap">
        {MESSAGES[mismatch]}
      </span>
    </div>
  );
};
